export default __webpack_public_path__ + "static/media/slider1.baa826d9.jpg";